import { render } from "./FileSelectorInput.vue?vue&type=template&id=4b9a39ae"
import script from "./FileSelectorInput.vue?vue&type=script&lang=js"
export * from "./FileSelectorInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/ideal-ventures/ideal-hr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__